angular.module('core').filter('schools', [ 'numberFilter',
	function($numberFilter) {
		return function(input) {
			if (_.isUndefined(input) || !_.isNumber(input)) {
				return '';
			} else {
				if (input === 1) {
					return input + ' school';
				} else {
					return $numberFilter(input) + ' schools';
				}
			}
		};
	}
]);
